import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/init_google_tag_manager";

enum GTMEvent {
    LISTING_MAP_CTA = "listing_map_cta"
}

export enum GTMEventAction {
    VIEW = "view",
    CLICK = "click"
}

export const hitGtmMapCtaEvent = (action: GTMEventAction) => {
    hitGoogleTagManager({
        event: GTMEvent.LISTING_MAP_CTA,
        cta_action: action
    });
};
import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/init_google_tag_manager";

enum GTMEvent {
    LISTING_MAP_CTA = "listing_map_cta"
}

export enum GTMEventAction {
    VIEW = "view",
    CLICK = "click"
}

export const hitGtmMapCtaEvent = (action: GTMEventAction) => {
    hitGoogleTagManager({
        event: GTMEvent.LISTING_MAP_CTA,
        cta_action: action
    });
};
